import React from 'react';
import { Modal } from 'react-bootstrap';

class InputModal extends React.Component {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.state = { showModal: false, children: {} };
  }

  close() {
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  changeValue(value) {
    const { children } = this.state;

    this.setState({
      children: {
        ...children,
        ...value
      },
    });
  }

  render() {
    const {
      Component, ComponentProps, submit, close, submitLabel, title, trigger,
      triggerInfo
    } = this.props;
    const { showModal, children } = this.state;

    return (
      <div style={{ display: 'inline' }}>
        {trigger(this.open, triggerInfo)}
        <Modal key="modal" show={showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>
              {title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Component
              {...ComponentProps}
              changeValue={(value) => { this.changeValue(value); }}
            />
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-success"
              onClick={() => { submit(children); }}
            >
              {submitLabel}
            </button>
            <button
              className="btn btn-danger"
              onClick={close ? () => { close(this.close); } : this.close}
            >
                            Kapat
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default InputModal;



// WEBPACK FOOTER //
// ./src/components/common/modal/input/index.js